import store from '@/store/index';
import { getParams, initApp } from './common';

class WebInstance {
	constructor() {}
	init(serverType) {
		return initApp(serverType).then((res) => {
			const iframeUrl = `${res.entrace_url}?${getParams()}&v=${new Date().getTime()}`;
			store.dispatch('setHallIfmUrl', iframeUrl);
		});
	}
}

export default WebInstance;
